angular.module('impactx.opengovernmentdata').controller('OpenGovernmentDataOverdueDialogCtrl', [
    'dataGen',
    '$mdDialog',
    OpenGovernmentDataOverdueDialogController]);

function OpenGovernmentDataOverdueDialogController(dataGen, $mdDialog) {
    var self = this;



    self.confirm = function () {
        $mdDialog.hide();
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };
}